import { render, staticRenderFns } from "./scpSkillsScores802.vue?vue&type=template&id=383c17a6&scoped=true"
import script from "./scpSkillsScores802.vue?vue&type=script&lang=js"
export * from "./scpSkillsScores802.vue?vue&type=script&lang=js"
import style0 from "./scpSkillsScores802.vue?vue&type=style&index=0&id=383c17a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c17a6",
  null
  
)

export default component.exports